import { render, staticRenderFns } from "./thereofEdit.vue?vue&type=template&id=42331987"
import script from "./thereofEdit.vue?vue&type=script&lang=js"
export * from "./thereofEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports